import { useSyncExternalStore } from 'react'

import { tastaturMerkmal, tastaturMerkmalAbonnieren } from '../lib/tastatur'

/**
 * Liegt gerade eine Bildschirmtastatur über der Anwendung?
 *
 * **Gelesen wird das Merkmal am Dokument, nicht die Messung.** Entschieden
 * wird an einer einzigen Stelle (`abstandNachziehen()` in `lib/tastatur.ts`),
 * und die setzt `data-tastatur`. Wer hier stattdessen selbst nachmessen
 * würde, hätte eine zweite Regel für dieselbe Frage — und zwei Regeln laufen
 * auseinander.
 *
 * `useSyncExternalStore` und kein `useState` mit Effekt: der Wert steht schon
 * im DOM, wenn diese Komponente das erste Mal zeichnet. Ein Effekt käme einen
 * Zeichendurchgang zu spät, und genau in dem Durchgang stünde der Knopf da,
 * den es nicht geben soll.
 *
 * Ohne `MutationObserver` (sehr alte Browser) bleibt es beim Anfangswert; der
 * Knopf steht dann wie früher immer da. Das ist der Zustand von vorher, kein
 * neuer Fehler.
 */
export function useTastaturOffen(): boolean {
  return useSyncExternalStore(tastaturMerkmalAbonnieren, tastaturMerkmal, () => false)
}
